import { lazy, Suspense } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { GlobalApiLoader } from './components/GlobalApiLoader';
import { PortalErrorBoundary } from './components/PortalErrorBoundary';

const PracticePortalApp = lazy(() =>
  import('./features/portal/PracticePortalApp').then((module) => ({
    default: module.PracticePortalApp,
  })),
);
const LoginPage = lazy(() =>
  import('./pages/LoginPage').then((module) => ({ default: module.LoginPage })),
);
const ProductHubPage = lazy(() =>
  import('./features/hub/ProductHubPage').then((module) => ({
    default: module.ProductHubPage,
  })),
);
const CommerceRoutes = lazy(() =>
  import('./features/commerce/CommerceRoutes').then((module) => ({
    default: module.CommerceRoutes,
  })),
);
const AccountSecurityPage = lazy(() =>
  import('./features/account/AccountSecurityPage').then((module) => ({
    default: module.AccountSecurityPage,
  })),
);
// PUBLIC checkout pages: no session needed, their own small chunk.
const CheckoutPage = lazy(() =>
  import('./features/checkout/CheckoutPage').then((module) => ({
    default: module.CheckoutPage,
  })),
);
const CheckoutThanksPage = lazy(() =>
  import('./features/checkout/CheckoutPage').then((module) => ({
    default: module.CheckoutThanksPage,
  })),
);
// PUBLIC: a parent's own account — its own sign-in, not the staff session.
const MyAccountRoutes = lazy(() =>
  import('./features/my-account/MyAccountPage').then((module) => ({
    default: module.MyAccountRoutes,
  })),
);
const SettingsRoutes = lazy(() =>
  import('./features/settings/SettingsRoutes').then((module) => ({
    default: module.SettingsRoutes,
  })),
);

const CrmRoutes = lazy(() =>
  import('./features/crm/CrmRoutes').then((module) => ({
    default: module.CrmRoutes,
  })),
);

/** Root composition point for routing and authentication providers. */
export function App() {
  return (
    <PortalErrorBoundary>
      <GlobalApiLoader />
      <Suspense
        fallback={
          <div className="loading">
            <span className="spinner" /> Loading…
          </div>
        }
      >
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/checkout/thanks" element={<CheckoutThanksPage />} />
          <Route path="/checkout/:slug" element={<CheckoutPage />} />
          <Route path="/hub" element={<ProductHubPage />} />
          <Route path="/commerce/*" element={<CommerceRoutes />} />
          <Route path="/settings/*" element={<SettingsRoutes />} />
          <Route path="/crm/*" element={<CrmRoutes />} />
          <Route path="/account" element={<AccountSecurityPage />} />
          <Route path="/my-account/*" element={<MyAccountRoutes />} />
          <Route path="/practices/*" element={<PracticePortalApp />} />
          <Route path="/sessions" element={<PracticePortalApp />} />
          <Route path="/submissions" element={<PracticePortalApp />} />
          <Route path="/analytics" element={<PracticePortalApp />} />
          <Route path="/course-types" element={<PracticePortalApp />} />
          <Route path="/quizzes/*" element={<PracticePortalApp />} />
          <Route path="/parent" element={<PracticePortalApp />} />
          <Route path="/" element={<Navigate to="/practices" replace />} />
          <Route path="*" element={<Navigate to="/practices" replace />} />
        </Routes>
      </Suspense>
    </PortalErrorBoundary>
  );
}
